import { BadgeType } from '@scaleaq/scaleui';
import { GensetMode } from '@scaleaq/sitecontrol-lib';

export const getBadgeType: (mode: GensetMode) => BadgeType = (mode: GensetMode): BadgeType => {
  switch (mode) {
    case GensetMode.Invalid:
    case GensetMode.Stop:
      return 'alarm';
    case GensetMode.Manual:
      return 'caution';
    case GensetMode.Auto:
    case GensetMode.SemiAuto:
      return 'success';
    case GensetMode.Test:
      return 'negative';
    default:
      return 'alarm';
  }
};
